<template>
  <b-row>
    <b-col cols="6">
      <r-form
          ref="form"
          :column-size="1"
          title="Property Designation"
          :columnOptions="{ md: 12 }"
          v-model="propertyDesignationForm"
          hide-loading
          read-only-disabled-mode
          :crud="true"
          @update:loading="loading = $event"
          :show-footer="false"
      />
      <r-form
          ref="form"
          :column-size="1"
          :crud="true"
          read-only-disabled-mode
          title="Building Layout Information"
          :columnOptions="{ md: 12 }"
          v-model="buildingLayoutInformationForm"
          hide-loading
          @update:loading="loading = $event"
          :show-footer="false"
      />
    </b-col>
    <b-col cols="6">
      <r-form
          ref="form"
          :column-size="1"
          :crud="true"
          read-only-disabled-mode
          title="Construction"
          :columnOptions="{ md: 12 }"
          v-model="constructionForm"
          hide-loading
          @update:loading="loading = $event"
          :show-footer="false"
      />
    </b-col>
  </b-row>
</template>

<script>
import RForm from '@/components/Form/RiskhubForm';
import { forEach } from 'lodash';
import {
  propertyDesignationForm as PropertyDesignationForm,
  buildingLayoutInformationForm as BuildingLayoutInformationForm,
  constructionForm as ConstructionForm
} from '@/services/Property/PropertyPremisesForm';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import PropertyPremises from "@/services/Property/PropertyPremises";

export default {
  name: 'Property-Item',
  components: {
    RForm,
  },
  mixins: [ErrorMixin],
  props: {
    property: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      disabled: true,
      loading: false,
      propertyPremises: null,
      propertyDesignationForm: null,
      buildingLayoutInformationForm: null,
      constructionForm: null,
    };
  },
  watch: {
    loading(newValue) {
      this.$emit('update:loading', newValue);
    },
  },
  methods: {
    setPropertyDesignationForm() {
      const form = PropertyDesignationForm();
      delete form.masterReference;

      forEach(this.propertyPremises, (value, key) => {
        if (key in form) {
          this.$set(form[key], 'value', value);
        }
      });

      this.propertyDesignationForm = form;
    },
    setBuildingLayoutInformationForm() {
      const form = BuildingLayoutInformationForm();
      delete form.masterReference;

      forEach(this.propertyPremises, (value, key) => {
        if (key in form) {
          this.$set(form[key], 'value', value);
        }
      });

      this.buildingLayoutInformationForm = form;
    },
    setConstructionForm() {
      const form = ConstructionForm();
      delete form.masterReference;

      forEach(this.propertyPremises, (value, key) => {
        if (key in form) {
          this.$set(form[key], 'value', value);
        }
      });

      this.constructionForm = form;
    },
    async fetchPropertyPremises() {
      this.loading = true;
      this.propertyPremises = {};

      try {
        const response = await PropertyPremises.find(this.property.propertyId);
        this.propertyPremises = response.data.data;
      } catch (e) {
        this.$router.push({ name: 'propertyPremises' }, () => {
          this.$notify({
            title: 'Property Premises not found',
            text: 'Property Premises could not be found.',
            type: 'error',
          });
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.fetchPropertyPremises();

    this.setPropertyDesignationForm();
    this.setBuildingLayoutInformationForm();
    this.setConstructionForm();
  },
};
</script>
